/* eslint-disable no-console */
import { useState, useEffect, useCallback } from 'react';

import { getAuthenticatedHttpClient, getAuthenticatedUser } from '@edx/frontend-platform/auth';
import { publish } from '@edx/frontend-platform';
import { getLocale, handleRtl, LOCALE_CHANGED } from '@edx/frontend-platform/i18n';

const useHeader = ({ config, username }) => {
  const [locale, setLocale] = useState(getLocale());

  useEffect(() => {
    const client = getAuthenticatedHttpClient();
    const baseUrl = config.LMS_BASE_URL;

    const updateLanguagePreference = async () => {
      const endpoint = '/api/user/v1/preferences/';
      const apiUrl = `${baseUrl}${endpoint}${username}`;

      try {
        await client.patch(apiUrl, { 'pref-lang': locale }, {
          headers: {
            'Content-Type': 'application/merge-patch+json',
          },
        });
      } catch (error) {
        console.error('Error updating language preference:', error);
      }
    };

    const updateSessionLanguage = async () => {
      const endpoint = '/lang_pref/session_language';
      const apiUrl = `${baseUrl}${endpoint}`;

      try {
        await client.patch(apiUrl, { 'pref-lang': locale }, {
          headers: {
            'Content-Type': 'application/merge-patch+json',
          },
        });
      } catch (error) {
        console.error('Error updating session language:', error);
      }
    };

    const updateLanguageSettings = async () => {
      const isAuthenticated = !!getAuthenticatedUser();
      const languageUpdatingFunction = isAuthenticated ? updateLanguagePreference : updateSessionLanguage;

      await languageUpdatingFunction();

      publish(LOCALE_CHANGED, locale);
      handleRtl();
    };

    updateLanguageSettings();
  }, [username, config.LMS_BASE_URL, locale]);

  const handleSelectLanguage = useCallback((lang) => {
    setLocale(lang);
  }, []);

  return { handleSelectLanguage };
};

export default useHeader;
